<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="invite-page">
  <div class="wizard-header" *ngIf="current_step < 2">
    <img [src]="academy_dp" (error)="onImgError($event)" class="wizard-logo" />
    <div class="wizard-title">Register with {{ academy_name ? (academy_name | titlecase) : 'the Academy' }}</div>
    <div class="wizard-progress">
      <span class="dot active"></span>
      <span class="bar" [class.active]="current_step >= 1"></span>
      <span class="dot" [class.active]="current_step >= 1"></span>
    </div>
    <div class="wizard-step-label">Step {{ current_step + 1 }} of 2 — {{ current_step === 0 ? 'Player info' : 'Confirmation' }}</div>
  </div>

  <div class="details-wrap">
  <div class="card mt-3" *ngIf="current_step === 0">
      <div class="card-body">
        <form class="form-sample" [formGroup]="addPersonalInfo" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12">
              <div class="row mt-3" style="margin: 0;">
                <div class="header-players mt-3 mb-4 col-lg-6 p-0">Personal info</div>
                <!-- <div class="col-lg-6 p-0" style="display: flex; justify-content: flex-end;">
                  <button class="btn bd-7 btn-outline-primary" style="text-decoration: none;height: 48px; border-radius: 5px; white-space: nowrap;">
                    Import player data
                  </button>
                </div> -->
              </div>
              <!-- Player contact error (for 13+ players) -->
              <app-field-error id="selfreg-contact-err"
                [control]="addPersonalInfo"
                [submitted]="submitted"
                [gate]="!!addPersonalInfo.errors?.['playerContactRequired']"
                [messages]="validationMessages.playerContact"
                wrapperClass="col-sm-12 p-0 col-form-label input-group mb-3"></app-field-error>
              <!-- <form class="form-sample" [formGroup]="addPersonalInfo" (ngSubmit)="onSubmit()"> -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="selfreg-email">Email address</label>
                    <div class="col-sm-12">
                      <input type="text" formControlName="email" class="form-control" name="email" id="selfreg-email"
                        placeholder="email@example.com" (change)="checkUser()"
                        [appAriaField]="addPersonalInfo.controls['email']" ariaDescribedBy="selfreg-email-err" [submitted]="submitted"/>
                        <p style="color: #9b9b9b; font-size: .85rem; margin: 0.2rem;" *ngIf="isUnder13">Note: Leave blank if student does not have email.</p>
                    </div>
                    <app-field-error id="selfreg-email-err"
                      [control]="addPersonalInfo.controls['email']"
                      [submitted]="submitted"
                      [messages]="validationMessages.email"></app-field-error>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="already_a_academy_member">
                      <small class="text-danger" >*Email address is already used by an academy member.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" matTooltip="Players under 13 require parent/guardian details; email is required for ages 13 and above." matTooltipPosition="above">Date of birth*</label>
                    <div class="col-sm-12">
                      <mat-form-field appearance="outline" style="width: 100%;">
                        <input matInput [matDatepicker]="picker" readonly placeholder="Select date"
                         (dateChange)="checkAge()"
                         style="font-size: 0.8125rem; padding: .4375rem .75rem;" formControlName="dob">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                      <!-- <p style="color: #9b9b9b; font-size: .85rem; margin: 0.2rem;">Hint: DD/MM/YYYY</p> -->
                    </div>
                    <app-field-error [control]="addPersonalInfo.controls['dob']" [submitted]="submitted" [messages]="validationMessages.dob"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="selfreg-fname">First name*</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" (input)="generateUsername()" name="fname" id="selfreg-fname" placeholder="Enter first name" formControlName="fname"
                        [appAriaField]="addPersonalInfo.controls['fname']" ariaDescribedBy="selfreg-fname-err" [submitted]="submitted">
                    </div>
                    <app-field-error id="selfreg-fname-err"
                      [control]="addPersonalInfo.controls['fname']"
                      [submitted]="submitted"
                      [messages]="validationMessages.firstName"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Last name</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" (input)="generateUsername()" formControlName="lname" name="lname" placeholder="Enter last name" />
                    </div>
                    <!-- <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="submitted && addPersonalInfo.controls['lname'].invalid">
                      <small class="text-danger">*Last Name is required.</small>
                    </div> -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="selfreg-username">Username*</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="username" id="selfreg-username"
                        (input)="checkUserName()"  [(ngModel)]="username"
                        name="username" placeholder="username"
                        [appAriaField]="addPersonalInfo.controls['username']" ariaDescribedBy="selfreg-username-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="selfreg-username-err"
                      [control]="addPersonalInfo.controls['username']"
                      [submitted]="submitted"
                      [gate]="usernameValid"
                      [messages]="validationMessages.username"></app-field-error>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="submitted && usernameValid && !addPersonalInfo.controls['username'].invalid">
                      <small class="text-danger">*Username already exists.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="selfreg-gender">Gender*</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="gender" name="gender" id="selfreg-gender" style="color: black;"
                        [appAriaField]="addPersonalInfo.controls['gender']" ariaDescribedBy="selfreg-gender-err" [submitted]="submitted">
                        <option value="" selected hidden>Select gender</option>
                        <option class="gender-drop" value="M">Male</option>
                        <option class="gender-drop" value="F">Female</option>
                        <option class="gender-drop" value="O">Other</option>
                      </select>
                    </div>
                    <app-field-error id="selfreg-gender-err"
                      [control]="addPersonalInfo.controls['gender']"
                      [submitted]="submitted"
                      [messages]="validationMessages.gender"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Blood group</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="blood_group" style="color: black;">
                        <option value="" selected hidden>Select blood group</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                      <label class="col-sm-12 col-form-label">Country code</label>
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                          <!-- <mat-label>Country code</mat-label> -->
                          <input type="text" class="main-height"
                                 placeholder="Pick a code"
                                 aria-label="Phone Number Extension"
                                 matInput
                                 [formControl]="phoneCodeControlPlayer"
                                 [matAutocomplete]="autophoneCodeControlPlayer">
                          <mat-autocomplete #autophoneCodeControlPlayer="matAutocomplete">
                            @for (option of filteredOptionsPhoneCodesPlayer | async ; track option) {
                              <mat-option [value]="option.dial_code">{{option.dial_code}} ({{option.name}})</mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                      <!-- Validation error display -->
                      <app-field-error [control]="phoneCodeControlPlayer" [submitted]="submitted" [messages]="validationMessages.phoneCode"></app-field-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                      <label class="col-sm-12 col-form-label" for="selfreg-phonenumber" matTooltip="Numbers are auto-formatted for the selected country code." matTooltipPosition="above">Phone number (WhatsApp preferred)</label>
                      <div class="col-sm-12">
                          <input class="form-control" formControlName="phonenumber" id="selfreg-phonenumber"
                            [appPhoneFormat]="phoneCodeControlPlayer.value"
                            placeholder="Enter phone number"
                            [appAriaField]="addPersonalInfo.controls['phonenumber']" ariaDescribedBy="selfreg-phonenumber-err" [submitted]="submitted" />
                      </div>
                      <app-field-error id="selfreg-phonenumber-err"
                        [control]="addPersonalInfo.controls['phonenumber']"
                        [submitted]="submitted"
                        [messages]="validationMessages.phoneNumber"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Registration authority</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="reg_authority" style="color: black;">
                        <option value="" selected hidden>Select registration authority</option>
                        <option value="AIFF">AIFF</option>
                        <option value="FIFA">FIFA</option>
                        <option value="USSF">USSF</option>
                        <option value="US Club Soccer">US Club Soccer</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Registration number</label>
                    <div class="col-sm-12">
                      <input class="form-control" formControlName="reg_number" placeholder="Enter registration number">
                    </div>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="!isUnder13" style="display: none;">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Membership plan</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="plan" name="plan" style="color: black;" (change)="onPlanChange($event)">
                        <option value="" selected hidden>Select membership plan</option>
                        <option *ngFor="let member of memberships" [value]="member._id">
                          {{ member.name || member | string: 'sentence' }} - {{member.amount| currencyLocale:locale.currency: locale.currency_format : locale.locale}} / {{((member.duration/30)| number:'1.0-0') || 0}} MONTH
                        </option>
                        <option value="remove">Remove membership plan</option>
                      </select>
                    </div>
                    <!-- <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="submitted && addPersonalInfo.controls['plan'].invalid">
                      <small class="text-danger">*Membership plan is required.</small>
                    </div> -->
                  </div>
                </div>
              </div>
              <!-- </form> -->

              <!-- <form class="form-sample"> -->
              <div class="header-players mt-5 col-lg-6 p-0 mb-0">Parent/Guardian info
                <span  *ngIf="isUnder13">(Compulsory)</span>
                <span  *ngIf="!isUnder13">(Optional)</span>
              </div>
              <div class="col-sm-12 p-0 col-form-label input-group mb-3">
                  <small class="text-danger"  *ngIf="isUnder13">*Parent/Guardian name and at least one of email or WhatsApp number are compulsory for players under 13</small>
              </div>
              <app-field-error id="selfreg-pcontact-err"
                [control]="addPersonalInfo"
                [submitted]="submitted"
                [gate]="!!addPersonalInfo.errors?.['parentContactRequired']"
                [messages]="validationMessages.parentContact"
                wrapperClass="col-sm-12 p-0 col-form-label input-group mb-3"></app-field-error>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="selfreg-pemail">Email</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="pemail" id="selfreg-pemail" placeholder="email@example.com"
                        (change)="checkParentUser()"
                        [appAriaField]="addPersonalInfo.controls['pemail']" ariaDescribedBy="selfreg-pemail-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="selfreg-pemail-err"
                      [control]="addPersonalInfo.controls['pemail']"
                      [submitted]="submitted"
                      [messages]="validationMessages.email"></app-field-error>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="parent_is_academy && !addPersonalInfo.controls['pemail'].errors?.['email']">
                      <small class="text-danger">{{ validationMessages.parentEmail.academy }}</small>
                    </div>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="parent_already_a_academy_member && !addPersonalInfo.controls['pemail'].errors?.['email']">
                      <small class="text-danger">{{ validationMessages.parentEmail.member }}</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-12 col-form-label" for="selfreg-pfname">First name*</label>
                        <div class="col-sm-12">
                            <input type="text" class="form-control" formControlName="pfname" id="selfreg-pfname" placeholder="Enter first name"
                              [appAriaField]="addPersonalInfo.controls['pfname']" ariaDescribedBy="selfreg-pfname-err" [submitted]="submitted" />
                        </div>
                        <app-field-error id="selfreg-pfname-err"
                          [control]="addPersonalInfo.controls['pfname']"
                          [submitted]="submitted"
                          [messages]="validationMessages.firstName"></app-field-error>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-12 col-form-label">Last name</label>
                        <div class="col-sm-12">
                            <input type="text" class="form-control" formControlName="plname" name="plname" placeholder="Enter last name" />
                        </div>
                    </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                      <label class="col-sm-12 col-form-label">Country code</label>
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                          <!-- <mat-label>Country code</mat-label> -->
                          <input type="text" class="main-height"
                                 placeholder="Pick a code"
                                 aria-label="Phone Number Extension"
                                 matInput
                                 [formControl]="phoneCodeControl"
                                 [matAutocomplete]="autophoneCodeControl">
                          <mat-autocomplete #autophoneCodeControl="matAutocomplete">
                            @for (option of filteredOptionsPhoneCodes | async ; track option) {
                              <mat-option [value]="option.dial_code">{{option.dial_code}} ({{option.name}})</mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                      <!-- Validation error display -->
                      <app-field-error [control]="phoneCodeControl" [submitted]="submitted" [messages]="validationMessages.phoneCode"></app-field-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                      <label class="col-sm-12 col-form-label" for="selfreg-pphonenumber">Phone number (WhatsApp preferred)</label>
                      <div class="col-sm-12">
                          <input class="form-control" formControlName="pphonenumber" id="selfreg-pphonenumber"
                            [appPhoneFormat]="phoneCodeControl.value"
                            placeholder="Enter phone number"
                            [appAriaField]="addPersonalInfo.controls['pphonenumber']" ariaDescribedBy="selfreg-pphonenumber-err" [submitted]="submitted" />
                      </div>
                      <app-field-error id="selfreg-pphonenumber-err"
                        [control]="addPersonalInfo.controls['pphonenumber']"
                        [submitted]="submitted"
                        [messages]="validationMessages.phoneNumber"></app-field-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Relation*</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="prelation" name="prelation" style="color: black;">
                        <option value="Parent">Parent</option>
                        <option value="Guardian">Guardian</option>
                      </select>
                    </div>
                  </div>
                </div>

              </div>
              <!-- </form> -->
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
                <div class="header-players mt-1 mb-5 col-lg-6 p-0">Licenses & Certificates (Optional)</div>
                <div class="uploading-contain col-12 mb-5">
                  <div class="media-container-empty" (click)="openMediumModal(exampleModalContent)">
                    <div class="upload-contain">
                      <img src="images/icons/upload.png" style="height: 2rem;">
                      <span class="primary-text bd-7">Upload your file</span>
                      <span class="primary-text">Files supported: JPG, PNG, PDF</span>
                    </div>
                  </div>
                  <div class="col-12 p-0 middle" *ngIf="licenseList.length > 0" style="max-height: 300px; overflow: auto;">
                    <div class="media-container col-12" style="cursor: pointer;"  *ngFor="let license of licenseList; let i = index">
                      <div class="class-text d-flex">
                        <div (click)="openAttachment(license.path)" class="d-flex col-7 p-0 over-flow-word">
                          <span>
                            <img src="images/icons-svg/dartle_emblem.svg" class="dartle-logo">
                          </span>
                          <span class="class-text-name mb-2 over-flow-word" [title]="license.name">{{license.name}}</span>
                        </div>
                        <div class="col-5 media-delete">
                          <!-- <span style="color: #9E9E9E; font-size: 20px;">50 KB</span> -->
                          <img src="images/icons/remove_circle.png" [swal]="warningWithCancel"
                            style="width: 24px; height: 28px;">
                        </div>
                        <swal #warningWithCancel type="warning" title="Are you sure?" confirmButtonText="Confirm"
                                  text="Do you want to remove this attachment" [showCancelButton]="true"
                                  cancelButtonClass="btn btn-outline-dark" (confirm)="removeAttachment(license.path)">
                              </swal>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3 mt-5" *ngIf="current_step === 0 && show_additional_info">
                  <div class="col-12 mb-3 d-flex pe-5" style="gap: 2rem;">
                    <div class="col-lg-10 d-flex flex-column p-0 fit-width" style="height: fit-content; gap: 2rem; max-height: 600px; overflow: auto;" #leftContainer>
                      <div id="card1" #card1 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Jersey information</div>
                            <form class="form-sample" [formGroup]="addJerseyInfo">
                              <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                      <div class="d-card w-100 d-flex">
                                          <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                              <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                  <div class="row show-style">
                                                      <div class="col-md-4">
                                                          <span>T-shirt size (Optional)</span>
                                                          <div class="form-group row mt-2">
                                                              <!-- <div class="col-sm-12">
                                                                  <input type="number" class="form-control form-boxes" formControlName="height" placeholder="cm" min="0" maxlength="3" />
                                                                  <div *ngIf="addPhysicalChara.get('height').invalid && addPhysicalChara.get('height').touched" class="text-danger">
                                                                      *Invalid height
                                                                  </div>
                                                              </div> -->
                                                            <div class="col-sm-12">
                                                                <select class="form-control form-boxes"
                                                                        formControlName="t_shirt_size"
                                                                        name="t_shirt_size"
                                                                        style="color: black;">
                                                                <option value="" hidden style="opacity: 0.8;">Select size</option>
                                                                <option *ngFor="let size of ['XS','S','M','L','XL','XXL', 'XXXL']" [value]="size">{{ size }}</option>
                                                                </select>
                                                            </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <span>Shorts size (Optional)</span>
                                                          <div class="form-group row mt-2">
                                                              <!-- <div class="col-sm-12">
                                                                  <input type="number" class="form-control form-boxes" formControlName="weight" placeholder="kg" min="0" maxlength="3" />
                                                                  <div *ngIf="addPhysicalChara.get('weight').invalid && addPhysicalChara.get('weight').touched" class="text-danger">
                                                                      *Invalid weight
                                                                  </div>
                                                              </div> -->
                                                            <div class="col-sm-12">
                                                                <select class="form-control form-boxes"
                                                                        formControlName="shorts_size"
                                                                        name="shorts_size"
                                                                        style="color: black;">
                                                                <option value="" hidden style="opacity: 0.8;">Select size</option>
                                                                <option *ngFor="let size of ['XS','S','M','L','XL','XXL', 'XXXL']" [value]="size">{{ size }}</option>
                                                                </select>
                                                            </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <span>Shoe size (Optional)</span>
                                                          <div class="form-group row mt-2">
                                                              <div class="col-sm-12">
                                                                <input type="number" class="form-control form-boxes"
                                                                    formControlName="shoe_size"
                                                                    name="shoe_size"
                                                                    min="0"
                                                                    oninput="this.value = this.value < 0 ? 0 : this.value"
                                                                    placeholder="Enter shoe size">
                                                                  <!-- <div *ngIf="addJerseyInfo.get('shoe_size').invalid && addJerseyInfo.get('shoe_size').touched" class="text-danger">
                                                                    *Invalid shoe size
                                                                  </div> -->
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div id="card2" #card2 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Physical characteristics</div>
                            <form class="form-sample" [formGroup]="addPhysicalChara">
                              <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                      <div class="d-card w-100 d-flex">
                                          <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                              <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                  <div class="row show-style">
                                                      <div class="col-md-4" >
                                                          <span>Height (Optional)</span>
                                                          <div class="form-group row mt-2">
                                                              <div class="col-sm-12">
                                                                  <input type="number" class="form-control form-boxes" formControlName="height" placeholder="cm" min="0" maxlength="3" />
                                                                  <div *ngIf="addPhysicalChara.get('height').invalid && addPhysicalChara.get('height').touched" class="text-danger">
                                                                      *Invalid height
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <span>Weight (Optional)</span>
                                                          <div class="form-group row mt-2">
                                                              <div class="col-sm-12">
                                                                  <input type="number" class="form-control form-boxes" formControlName="weight" placeholder="kg" min="0" maxlength="3" />
                                                                  <div *ngIf="addPhysicalChara.get('weight').invalid && addPhysicalChara.get('weight').touched" class="text-danger">
                                                                      *Invalid weight
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <span>BMI (Optional)</span>
                                                          <div class="form-group row mt-2">
                                                              <div class="col-sm-12">
                                                                  <input type="text" class="form-control form-boxes" formControlName="bmi" placeholder="kg/m²" readonly/>
                                                                  <div *ngIf="addPhysicalChara.get('bmi').invalid && addPhysicalChara.get('bmi').touched" class="text-danger">
                                                                     *Invalid BMI
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div id="card3" #card3 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Sport information</div>
                            <form class="form-sample" [formGroup]="addSportInfo">
                              <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                      <div class="d-card w-100 d-flex">
                                          <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                              <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                <div class="row show-style">
                                                  <div class="col-md-6" >
                                                      <span>Sport</span>
                                                      <div class="form-group row mt-2">
                                                        <div class="col-sm-12">
                                                          <select class="form-control" formControlName="sport_name" name="sport_name" style="color: black;">
                                                            <option value="" selected hidden>Select sport</option>
                                                            <option class="gender-drop" *ngFor="let sport of sportsList" [value]="sport._id">
                                                              {{ sport.sports | string : 'sentence' }}
                                                              @if (sport.alias) {
                                                                ({{sport.alias}})
                                                              }
                                                            </option>
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <span>Position</span>
                                                        <div class="form-group row mt-2">
                                                            <div class="col-sm-12">
                                                                <input type="text" formControlName="position"
                                                                    class="form-control form-boxes" name="position"
                                                                    placeholder="Enter position" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div id="card4" #card4 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Address information</div>
                            <form class="form-sample" [formGroup]="addAddressInfo">
                              <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                      <div class="d-card w-100 d-flex">
                                          <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                              <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                <div class="mb-2ss">
                                                  <span>Country</span>
                                                  <div class="form-group row mt-2">
                                                    <div class="col-sm-12">
                                                        <div ngbDropdown>
                                                            <button class="btn form-control btn-outline-dark" type="button"
                                                                id="dropdownClass" ngbDropdownToggle
                                                                style="text-align: left;padding: 0rem 1rem;border: 1px solid #ced4da;">
                                                                {{countryName}}
                                                            </button>
                                                            <div ngbDropdownMenu aria-labelledby="dropdownClass" style="min-width: 100%;">
                                                                <input type="text" class="form-control filter-search"
                                                                    [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}"
                                                                    placeholder="Country name" (input)="search()" />
                                                                <div>
                                                                    <div class="dropdown-item filter-elem"
                                                                        *ngFor="let elem of countryList  | slice:0:25;"
                                                                        (click)="selectCountry(elem)">
                                                                        {{elem.country}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row show-style">
                                                  <div class="col-md-6" >
                                                    <span>Address</span>
                                                    <div class="form-group row mt-2">
                                                        <div class="col-sm-12">
                                                            <input type="text" formControlName="address"
                                                                class="form-control form-boxes" name="fname"
                                                                placeholder="Enter address" />
                                                        </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-md-6">
                                                    <span>County/Province/State</span>
                                                    <div class="form-group row mt-2">
                                                        <div class="col-sm-12">
                                                            <div ngbDropdown>
                                                                <button class="btn form-control btn-outline-dark" type="button"
                                                                    id="dropdownClass" ngbDropdownToggle
                                                                    style="text-align: left;padding: 0rem 1rem;border: 1px solid #ced4da;">
                                                                    {{stateName}}
                                                                </button>
                                                                <div ngbDropdownMenu aria-labelledby="dropdownClass" style="min-width: 100%;">
                                                                    <input type="text" class="form-control filter-search"
                                                                        [(ngModel)]="searchTermState" [ngModelOptions]="{standalone: true}"
                                                                        placeholder="State name" (input)="searchState()" />
                                                                    <div>
                                                                        <div class="dropdown-item filter-elem" *ngFor="let elem of stateList"
                                                                            (click)="selectState(elem)">
                                                                            {{elem}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row show-style">
                                                    <div class="col-md-6" >
                                                      <span>City</span>
                                                      <div class="form-group row mt-2">
                                                          <div class="col-sm-12">
                                                              <input type="text" class="form-control" formControlName="city" name="city"
                                                                  placeholder="Enter city" />
                                                          </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                      <span>Postal code</span>
                                                      <div class="form-group row mt-2">
                                                          <div class="col-sm-12">
                                                              <div ngbDropdown>
                                                                  <button class="btn form-control btn-outline-dark" type="button"
                                                                      id="dropdownClass" ngbDropdownToggle
                                                                      style="text-align: left;padding: 0rem 1rem;border: 1px solid #ced4da;">
                                                                      {{pincodeName}}
                                                                  </button>
                                                                  <div ngbDropdownMenu aria-labelledby="dropdownClass" style="min-width: 100%;">
                                                                      <input type="text" class="form-control filter-search"
                                                                          [(ngModel)]="searchTermPincode" [ngModelOptions]="{standalone: true}"
                                                                          placeholder="Search postal code" (input)="searchPostcode()" />
                                                                      <div>
                                                                          <div class="dropdown-item filter-elem"
                                                                              *ngFor="let elem of pincodeList | slice:0:25;"
                                                                              (click)="selectPostcode(elem)">
                                                                              {{elem}}
                                                                          </div>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                    </div>
                                                </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div id="card5" #card5 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Education history</div>
                            <div class="card p-3 mb-5">
                              <form class="form-sample" [formGroup]="addEducation">
                                <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                    <div class="d-card w-100 d-flex">
                                      <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                        <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                          <span>Education institute*</span>
                                          <div class="form-group row mt-2" style="margin-bottom: 0rem;">
                                            <div class="col-sm-12">
                                              <input type="text" formControlName="institute" class="form-control form-boxes" placeholder="Institute name" />
                                            </div>
                                          </div>
                                          <div class="row mt-3 mb-3 show-style">
                                            <div class="col-md-6" >
                                              <span>Discipline*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <input type="text" formControlName="discipline" class="form-control form-boxes" placeholder="Enter discipline" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-3">
                                              <span>Start year*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <input type="number" min="1900" formControlName="start_Year" class="form-control form-boxes" placeholder="Start year" maxlength="4"  />
                                                  <div *ngIf="addEducation.get('start_Year').invalid && addEducation.get('start_Year').touched" class="text-danger">
                                                    *Invalid start year
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-3">
                                              <span>End year*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <input type="number" min="1901" formControlName="end_Year" class="form-control form-boxes" placeholder="End year" maxlength="4" />
                                                  <div *ngIf="addEducation.get('end_Year').invalid && addEducation.get('end_Year').touched" class="text-danger">
                                                    *Invalid end year
                                                  </div>
                                                  <div *ngIf="addEducation.errors?.startYearLessThanEndYear" class="text-danger">
                                                    *End year must be after start year
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-3 p-0">
                                            <div class="form-group row">
                                              <div class="col-sm-12">
                                                <button matRipple class="btn btn-primary main-height" [disabled]="!checkFormValidity()" (click)="createEducation()"
                                                        style="width: inherit; padding: 0.8rem 3rem 0.8rem 3rem; min-width: 10rem;">Save</button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>


                            </div>
                            <div class="card p-4" *ngIf="educationList.length > 0" style="background: #F7F7F7;">
                              <div class="w-100 profile-padding">
                                <div class="d-card w-100 d-flex">
                                    <div class="d-card w-100 d-flex">
                                        <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                            <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                <span class="header-players ml-4">Education history</span>
                                                <div class="col-12 mt-3 mb-3">
                                                  <div class="row">
                                                    <div class="col-md-6 show-style" *ngFor="let educations of educationList; let i=index">
                                                      <div class="education-box">
                                                          <div style="float: right; cursor: pointer;" (click)="removeEducation(i)">
                                                            <img src="images/icons/remove_circle.png" style="width: 24px; height: 28px;">
                                                          </div>
                                                          <div class="d-flex">
                                                            <img class="mt-1" src="images/icons/school.png" style="width: 24px; height: 28px;">
                                                            <div class="ms-2 over-flow-word" style="padding: .3rem;">
                                                              <div class="text-bold mb-1 over-flow-word" style="text-transform: capitalize; color: #FF6634;">
                                                                {{educations.institute}}</div>
                                                              <div class="text-base f-bold mb-1 over-flow-word"
                                                                  style="color: #959595;">
                                                                  {{educations.discipline | string : 'sentence'}}</div>
                                                              <div class="text-bold mb-1">
                                                                {{educations.start_date}} - {{educations.end_date}}</div>
                                                            </div>
                                                          </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="card6" #card6 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Career history</div>
                            <div class="card p-3 mb-5">
                              <form class="form-sample" [formGroup]="addCareer">
                                <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                    <div class="d-card w-100 d-flex">
                                      <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                        <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                          <span>Academy*</span>
                                          <div class="form-group row mt-2" style="margin-bottom: 0rem;">
                                            <div class="col-sm-12">
                                              <input type="text" formControlName="academy" class="form-control form-boxes" placeholder="Academy name" />
                                            </div>
                                          </div>
                                          <div class="row mt-3 mb-3 show-style">
                                            <div class="col-md-6" >
                                              <span>Role*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <input type="text" formControlName="role" class="form-control form-boxes" placeholder="Enter role" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-3">
                                              <span>Start date*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <mat-form-field appearance="outline" style="width: 100%;">
                                                    <input matInput [matDatepicker]="picker1" readonly placeholder="Select date"
                                                           style="font-size: 0.8125rem; padding: .4375rem .75rem;" formControlName="start_date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker1></mat-datepicker>
                                                  </mat-form-field>
                                                  <div *ngIf="addCareer.get('start_date').invalid && addCareer.get('start_date').touched" class="text-danger">
                                                    *Invalid start date
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-3">
                                              <span>End date*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <mat-form-field appearance="outline" style="width: 100%;">
                                                    <input matInput [matDatepicker]="picker2" readonly placeholder="Select date"
                                                           style="font-size: 0.8125rem; padding: .4375rem .75rem;" formControlName="end_date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker2></mat-datepicker>
                                                  </mat-form-field>
                                                  <div *ngIf="addCareer.get('end_date').invalid && addCareer.get('end_date').touched" class="text-danger">
                                                    *Invalid end date
                                                  </div>
                                                  <div *ngIf="addCareer.errors?.startDateBeforeEndDate" class="text-danger">
                                                    *End date must be after start date
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-3 p-0">
                                            <div class="form-group row">
                                              <div class="col-sm-12">
                                                <button matRipple class="btn btn-primary main-height" [disabled]="!checkCareerValidity()" (click)="createCareer()"
                                                        style="width: inherit; padding: 0.8rem 3rem 0.8rem 3rem; min-width: 10rem;">Save</button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>

                            </div>
                            <div class="card p-4" *ngIf="careerList.length > 0" style="background: #F7F7F7;">
                              <div class="w-100 profile-padding">
                                <div class="d-card w-100 d-flex">
                                    <div class="d-card w-100 d-flex">
                                        <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                            <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                <span class="header-players ml-4">Career history</span>
                                                <div class="col-12 mt-3 mb-3">
                                                  <div class="row">
                                                    <div class="col-md-6 show-style" *ngFor="let career of careerList; let i=index">
                                                      <div class="education-box">
                                                          <div style="float: right; cursor: pointer;" (click)="removeCareer(i)">
                                                            <img src="images/icons/remove_circle.png" style="width: 24px; height: 28px;">
                                                          </div>
                                                          <div class="d-flex">
                                                            <img class="mt-1" src="images/icons/work.png" style="width: 24px; height: 28px;">
                                                            <div class="ms-2 over-flow-word" style="padding: .3rem;">
                                                              <div class="text-bold mb-1 over-flow-word" style="text-transform: capitalize; color: #FF6634;">
                                                                {{career.academy_name}}</div>
                                                              <div class="text-base f-bold mb-1 over-flow-word"
                                                                  style="color: #959595;">
                                                                  {{career.role | string: 'sentence'}}</div>
                                                              <div class="text-bold mb-1">
                                                                {{ career.start_date | dateTime: 'MMMM yyyy' }} - {{ career.end_date | dateTime: 'MMM yyyy' }}</div>
                                                            </div>
                                                          </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div id="card7" #card7 class="col-lg-12 p-0">
                        <div class="card">
                          <div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Achievements</div>
                            <div class="card p-3 mb-5">
                              <form class="form-sample" [formGroup]="addAchievement">
                                <div class="w-100 profile-padding">
                                  <div class="d-card w-100 d-flex">
                                    <div class="d-card w-100 d-flex">
                                      <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                        <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                          <span>Event*</span>
                                          <div class="form-group row mt-2" style="margin-bottom: 0rem;">
                                            <div class="col-sm-12">
                                              <input type="text" formControlName="event" class="form-control form-boxes" name="event" placeholder="Event name" />
                                              <div *ngIf="addAchievement.get('event').invalid && addAchievement.get('event').touched" class="text-danger">
                                                *Event is required
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row mt-3 mb-3 show-style">
                                            <div class="col-md-6" >
                                              <span>Achievement*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <input type="text" formControlName="achievement" class="form-control form-boxes" name="achievement" placeholder="Enter achievement" />
                                                  <div *ngIf="addAchievement.get('achievement').invalid && addAchievement.get('achievement').touched" class="text-danger">
                                                    *Achievement is required
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-6">
                                              <span>Year*</span>
                                              <div class="form-group row mt-2">
                                                <div class="col-sm-12">
                                                  <input type="number" min="1900" formControlName="year" class="form-control form-boxes" placeholder="Year" maxlength="4" />
                                                  <div *ngIf="addAchievement.get('year').invalid && addAchievement.get('year').touched" class="text-danger">
                                                    *Invalid year
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-3 p-0">
                                            <div class="form-group row">
                                              <div class="col-sm-12">
                                                <button matRipple class="btn btn-primary main-height" [disabled]="!checkAchievementValidity()" (click)="saveAchievement()" style="width: inherit; padding: 0.8rem 3rem 0.8rem 3rem; min-width: 10rem;">
                                                  Save
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>

                            </div>
                            <div class="card p-4" *ngIf="achievementList.length > 0" style="background: #F7F7F7;">
                              <div class="w-100 profile-padding">
                                <div class="d-card w-100 d-flex">
                                    <div class="d-card w-100 d-flex">
                                        <div class="d-card-body d-flex flex-column w-100 justify-content-between">
                                            <div class="d-flex flex-column justify-content-between grid-gap w-100">
                                                <span class="header-players ml-4">Achievement list</span>
                                                <div class="col-12 mt-3 mb-3">
                                                  <div class="row">
                                                    <div class="col-md-6 show-style" *ngFor="let achieve of achievementList; let i=index">
                                                      <div class="education-box">
                                                          <div style="float: right; cursor: pointer;" (click)="removeAchievement(i)">
                                                            <img src="images/icons/remove_circle.png" style="width: 24px; height: 28px;">
                                                          </div>
                                                          <div class="d-flex">
                                                            <img class="mt-1" src="images/icons/stars.png" style="width: 24px; height: 28px;">
                                                            <div class="ms-2 over-flow-word" style="padding: .3rem;">
                                                              <div class="text-bold mb-1 over-flow-word" style="text-transform: capitalize; color: #FF6634;">
                                                                {{achieve.event_name}}</div>
                                                              <div class="text-base f-bold mb-1 over-flow-word"
                                                                  style="color: #959595;">
                                                                  {{achieve.achievement | string:'sentence'}}</div>
                                                              <div class="text-bold mb-1">
                                                                {{achieve.date}}</div>
                                                            </div>
                                                          </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="web-show h-100 col-lg-2 p-0 show-selection">
                      <div class="card d-flex flex-column p-0" style="height: 600px;">
                        <div class="text-selection-box" (click)="scrollToCard('card1')">
                          Jersey information
                        </div>
                        <div class="text-selection-box" (click)="scrollToCard('card2')">
                          Physical characteristics
                        </div>
                        <div class="text-selection-box" (click)="scrollToCard('card3')">
                          Sport information
                        </div>
                        <div class="text-selection-box" (click)="scrollToCard('card4')">
                          Address information
                        </div>
                        <div class="text-selection-box" (click)="scrollToCard('card5')">
                          Education history
                        </div>
                        <div class="text-selection-box" (click)="scrollToCard('card6')">
                          Career history
                        </div>
                        <div class="text-selection-box" (click)="scrollToCard('card7')">
                          Achievements
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="row mt-3" style="margin: 0;">
                  <div class="additional-players mt-1 mb-5 col-lg-6 p-0" (click)="showAdditional()">Additional info (Optional)
                    <i [class]="show_additional_info ? 'bi bi-chevron-up' : 'bi bi-chevron-down'" style="font-size: 1rem;"></i>
                  </div>
                  <div class="col-lg-6 p-0" style="display: flex; justify-content: flex-end;" *ngIf="!editMode">
                    <button matRipple class="btn bd-7 btn-primary wizard-btn">
                      Add player data
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </form>
      </div>
  </div>


  <!-- <div class="card mt-3" *ngIf="current_step === 0 && !editMode">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="row mt-3" style="margin: 0;">
            <div class="additional-players mt-1 mb-3 col-lg-6 p-0" style="font-size: 22px;">{{playersAddedList.length}} Players added</div>
            <div class="col-lg-6 p-0" style="display: flex; justify-content: flex-end;">
              <button matRipple class="btn bd-7 btn-primary main-height" [disabled]="playersAddedList.length === 0" (click)="nextStep()" style="text-decoration: none; padding: 1rem 5rem;
                 border-radius: 5px; white-space: nowrap; align-items: center; display: flex;">
                Go to confirm page
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="card mt-3" *ngIf="current_step === 1">
    <div class="card-body">
      <div class="row">
        <div class="col-12 mob-pad">
          <div class="row mt-3" style="margin: 0;">
            <div class="header-players mt-1 mb-5 col-lg-6 p-0">Player list ({{playersAddedList.length}} players)</div>
            <div class="col-lg-6 p-0" style="display: flex; justify-content: flex-end;">
              <!-- <button class="btn bd-7 btn-outline-primary" style="text-decoration: none;height: 48px; border-radius: 5px; white-space: nowrap;">
                Import player data
              </button> -->
            </div>
          </div>

          <div *ngFor="let player of playersAddedList; let i = index">
            <div class="student-contain">
                <div class="web-show number-list">{{i+1}}</div>
                <div class="d-flex justify-content-between">
                  <div class="profile">
                    <img class="profile-pic" [src]="player.student_info?.basic_information?.dp" (error)="onImgError($event)">
                    <div style="margin: auto 0;">
                        <div class="title" style="text-transform: capitalize;">
                            {{player.first_name }} {{player.last_name || "" }}
                        </div>
                        <div class="academy-font" style="color: #969696;">
                          <span *ngIf="player.gender === 'M'">Male</span>
                          <span *ngIf="player.gender === 'F'">Female</span>
                          <span *ngIf="player.gender === 'O'">Other</span>
                          | {{player.dob?.split(' ')?.join('/')}}
                        </div>
                    </div>
                  </div>
                  <span class="mobile-show col-2">
                    <div class="d-flex justify-content-between align-items-center" style="cursor: pointer;">
                      <img src="images/icons/edit.png" (click)="editIndividualMember(i)" style="width: 24px; height: 28px;">
                      <img src="images/icons/remove_circle.png" (click)="removeSelectedMember(i)" style="width: 24px; height: 28px;">
                    </div>
                  </span>

                </div>

                <hr class="mobile-show  horizontal">
                <div class="d-flex justify-content-between">
                  <div style="display: flex; align-items: center; visibility: hidden;">
                    <div ngbDropdown>
                      <button class="btn form-control over-flow-word main-height" type="button" id="dropdownClass" ngbDropdownToggle
                        style="text-align: left; padding: 0rem 1rem; border: 1px solid #ced4da; height: 41px; margin: .25em 0; width: 8rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        title="">
                        {{ getMembershipName(player.product_role) || "Select plan" }}
                      </button>
                      <div class="main-height over-flow-word" ngbDropdownMenu aria-labelledby="dropdownClass" style="min-width: 100%;">
                        <div *ngFor="let member of memberships; let i = index" (click)="editPlan(i, member)" class="dropdown-item membership">
                          {{member.name | string:'sentence'}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" d-flex align-items-center">
                    <div class="d-flex">
                      <img src="images/icons/attach_file.png" style="width: 24px; height: 26px;">
                      <div class="mr-2" style="text-transform: capitalize; color: #FF6634;">
                        {{player.licenses.length}} documents</div>
                    </div>
                  </div>
                </div>

                <div class="web-show" style="align-content: center;">
                  <div class="d-flex align-items-center" style="justify-content: flex-end;">
                    <div class="d-flex" style="cursor: pointer; grid-gap: 2rem;">
                      <img src="images/icons/edit.png" (click)="editIndividualMember(i)" click style="width: 24px; height: 28px;">
                      <img src="images/icons/remove_circle.png" (click)="removeSelectedMember(i)" style="width: 24px; height: 28px;">
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>
    <!-- members adding save -->
    <div class="row mt-3">
      <div class="col-12">
          <div class="row mt-3 last-mob" style="margin: 0; justify-content: end;">
            <div class="col-6 p-0 last-full mb-3" style="display: none;">
              <button matRipple (click)="previousStep(); clearFullForm();" class="btn bd-7 btn-outline-primary main-height last-full" style="padding: 1rem 5rem; text-decoration: none; border-radius: 5px; white-space: nowrap; display: flex; align-items: center;">
                Add more players
              </button>
            </div>
            <div class="col-6 p-0 last-full mb-3" style="display: flex; justify-content: flex-end;">
              <button matRipple [swal]="warningSave" class="btn bd-7 btn-primary wizard-btn last-full main-height" [disabled]="isRegistering">
                <span *ngIf="!isRegistering">Confirm</span>
                <span *ngIf="isRegistering" class="d-flex align-items-center justify-content-center" style="gap: 0.5rem;">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>Registering...</span>
                </span>
              </button>
              <swal #warningSave type="warning" title="Are you sure?" confirmButtonText="Confirm"
                text="Do you want to add these players to the academy?" [showCancelButton]="true"
                cancelButtonClass="btn btn-outline-dark" (confirm)="saveAllPlayerData()">
              </swal>
            </div>
          </div>
          <div class="text-xs" style="text-align: end;">
            By clicking Submit, you confirm that the academy has collected the required parental consent (offline or digital) for all players,
            <br>
            <span style="white-space: nowrap;">and you agree to Dartle's
              <a target="_blank" href="https://dartle.app/privacy-policy.html" style="text-decoration:none;color:#54a8ec;">Privacy Policy</a>
              and
              <a target="_blank" href="https://dartle.app/terms-and-conditions.html" style="text-decoration:none;color:#54a8ec;">Terms &amp; Conditions</a></span>
          </div>
         
<!--           <div class="text-xs" style="text-align: end;">By clicking 'Confirm,' you agree to Dartle's
            <a
              target="_blank"
              href="https://dartle.app/privacy-policy.html"
              style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#54a8ec;font-size:15px;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">
              Privacy Policy</a> and
            <a
              target="_blank"
              href="https://dartle.app/terms-and-conditions.html"
              style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#54a8ec;font-size:15px;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">
              Terms & Conditions</a>
          </div> -->
        </div>
      </div>
    </div>
  </div>


  <!-- Edit save -->
  <div class="card mt-3" *ngIf="editMode">
    <div class="card-body">
      <div class="row mt-3 last-mob">
        <div class="col-12">
            <div class="row mt-3" style="margin: 0;">
              <div class="col-6 p-0 last-full mb-3">
                <button matRipple (click)="CancelEdit()" class="btn bd-7 btn-outline-primary wizard-btn last-full main-height">
                  Cancel
                </button>
              </div>
              <div class="col-6 p-0 last-full mb-3" style="display: flex; justify-content: flex-end;">
                <button matRipple (click)="confirmIndividualEdit()" class="btn bd-7 btn-primary wizard-btn last-full main-height">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>


  <ng-template class="modal fade" #exampleModalContent let-modal>
    <div class="modal-content">
        <div class="modal-header d-flex justify-content-between col-12" style="padding: 1rem 2rem;">
          <h5 class="modal-title mt-2 bd-7" id="exampleModalLabel"><span>
              Upload file</span>
          </h5>
          <img class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()"
            class="model-close" src="images/icons/cancel.png">
        </div>
        <input type="file" (change)="fileChangeEvent($event)" #myfileid id="myfileid" style="display: none;" />
        <!-- <input type="file" (change)="fileChangeEvent($event)" id="myfileid" style="display: none;" /> -->
        <div class="modal-body col-12">
            <div class="w-100 d-flex justify-content-center pt-5 pb-5" *ngIf="fileSelect"
                (click)="openFileSelect()">
                <img src="images/samples/ic_add_image.png" />
            </div>
            <div class="w-100 d-flex justify-content-center pt-5 pb-5" *ngIf="fileSelectDone || afterImageUpload"
                (click)="openFileSelect()">
                <img src="images/icons/ic_success_full.png"  alt="" />
            </div>
            <!-- <image-cropper [imageChangedEvent]="imageChangedEvent" *ngIf="afterImageUpload"
                [maintainAspectRatio]="false" [resizeToWidth]="900" [resizeToHeight]="900" [aspectRatio]="1 / 1"
                format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" [output]="'base64'"
                (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" class="cropper-maxh">
            </image-cropper> -->
        </div>
        <div class="modal-footer col-12">
            <button matRipple type="button" class="btn btn-dark al-start alert-footer main-height" (click)="openFileSelect()">Choose file</button>
            <button matRipple type="button" class="btn btn-success alert-footer main-height"
                (click)="uploadAttachment();">Upload</button>
            <button matRipple type="button" class="btn btn-light alert-footer main-height" data-dismiss="modal"
                (click)="modal.dismiss()">Cancel</button>
        </div>
    </div>
  </ng-template>

  </div>

  <!-- ============================ STEP 2 — CONFIRMATION ============================ -->
  <div *ngIf="current_step === 2">
    <app-registration-confirmation [name]="confirmationName"></app-registration-confirmation>
  </div>

</div>
